import { CountrySelect } from "../../../react4xp/parts/country-select/country-select";

export default (props) => <CountrySelect {...props} />
